function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.36529 6.09524C3.76246 6.09524 4.08742 5.75238 4.08742 5.33333C4.08742 4.91429 3.76246 4.57143 3.36529 4.57143C2.96811 4.57143 2.64315 4.91429 2.64315 5.33333C2.64315 5.75238 2.96811 6.09524 3.36529 6.09524ZM5.5317 2.66667H5.17063V1.90476C5.17063 0.853333 4.36184 0 3.36529 0C2.36874 0 1.55995 0.853333 1.55995 1.90476H2.24598C2.24598 1.25333 2.74786 0.72381 3.36529 0.72381C3.98272 0.72381 4.4846 1.25333 4.4846 1.90476V2.66667H1.19888C0.801707 2.66667 0.476746 3.00952 0.476746 3.42857V7.2381C0.476746 7.65714 0.801707 8 1.19888 8H5.5317C5.92887 8 6.25383 7.65714 6.25383 7.2381V3.42857C6.25383 3.00952 5.92887 2.66667 5.5317 2.66667ZM5.5317 7.2381H1.19888V3.42857H5.5317V7.2381Z",
  fill: "#55586F"
});

function SvgPadlockOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    viewBox: "0 0 7 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockOpen);
export default __webpack_public_path__ + "static/media/padlock-open.9c16498b.svg";
export { ForwardRef as ReactComponent };